// import json config files
import defaultConfig from './default.json';
import config1 from './config1.json';

// create map object to map domains to configs
const domainMap = {
  "starphone-appdev.star2starglobal.net": defaultConfig,
  "localhost": config1,
  "localhost:8082": config1,
  "localhost:3000": config1,
};

// create static func getConfig that takes in domain string and returns config object
const getDomainConfig = function (domain) {
  if (typeof domainMap[domain] !== "undefined") {
    return domainMap[domain];
  } else {
    console.warn(`No config file found for input domain ${domain}.  Using default configuration`);
    return defaultConfig;
  }
};

export {
  getDomainConfig
};